const SLOW_NETWORK_THRESHOLD = 100; // kB per second

let slowWarningThrown = false;

export function attachLoadingTimer<T extends { data: ArrayBuffer | Blob }>(p: Promise<T>) {
    const startTime = performance.now();

    p.then(result => {
        if (slowWarningThrown) {
            return;
        }

        let fileSize = 0;
        const endTime = performance.now();
        if ('byteLength' in result.data) {
            fileSize = result.data.byteLength;
        } else if ('size' in result.data) {
            fileSize = result.data.size;
        }

        if (startTime && endTime && fileSize > 50000) {
            const resultTime = endTime - startTime; // in milliseconds

            // if download speed is less than 100 kB per second, throw slow loading warning
            if (fileSize / resultTime < SLOW_NETWORK_THRESHOLD) {
                console.warn('Slow network detected. Scene experience may be degraded.');
                slowWarningThrown = true;
            }
        }
    }).catch(() => {
        // Do nothing
    });

    return p;
}
